// Auto-generated from docs/kablobacaıCizim.dxf
// Bu dosya scripts/extractDxfDrawing.js tarafından üretilmiştir. Manuel düzenlemeyin.

export const KABLO_BACASI_DRAWING = {
  width: 650.88,
  height: 839.35,
  lines: [
  {
    "x1": 137.01,
    "y1": 490.36,
    "x2": 110.77,
    "y2": 464.12
  },
  {
    "x1": 215.12,
    "y1": 436.84,
    "x2": 215.12,
    "y2": 631.82
  },
  {
    "x1": 49.12,
    "y1": 652.16,
    "x2": 49.12,
    "y2": 416.54
  },
  {
    "x1": 425.83,
    "y1": 698.84,
    "x2": 425.83,
    "y2": 272.2
  },
  {
    "x1": 317.71,
    "y1": 324.78,
    "x2": 317.71,
    "y2": 711.96
  },
  {
    "x1": 314.31,
    "y1": 324.78,
    "x2": 314.31,
    "y2": 711.96
  },
  {
    "x1": 304.08,
    "y1": 324.78,
    "x2": 304.08,
    "y2": 711.96
  },
  {
    "x1": 307.48,
    "y1": 324.78,
    "x2": 307.48,
    "y2": 711.96
  },
  {
    "x1": 293.84,
    "y1": 324.78,
    "x2": 293.84,
    "y2": 711.96
  },
  {
    "x1": 297.25,
    "y1": 324.78,
    "x2": 297.25,
    "y2": 711.96
  },
  {
    "x1": 271.6,
    "y1": 324.78,
    "x2": 271.6,
    "y2": 711.96
  },
  {
    "x1": 269.27,
    "y1": 324.78,
    "x2": 269.27,
    "y2": 711.96
  },
  {
    "x1": 264.61,
    "y1": 324.78,
    "x2": 264.61,
    "y2": 711.96
  },
  {
    "x1": 266.94,
    "y1": 324.78,
    "x2": 266.94,
    "y2": 711.96
  },
  {
    "x1": 259.95,
    "y1": 324.73,
    "x2": 259.95,
    "y2": 711.96
  },
  {
    "x1": 262.28,
    "y1": 324.73,
    "x2": 262.28,
    "y2": 711.96
  },
  {
    "x1": 250.63,
    "y1": 324.78,
    "x2": 250.63,
    "y2": 711.96
  },
  {
    "x1": 252.95,
    "y1": 324.78,
    "x2": 252.95,
    "y2": 711.96
  },
  {
    "x1": 245.97,
    "y1": 324.73,
    "x2": 245.97,
    "y2": 711.96
  },
  {
    "x1": 248.29,
    "y1": 324.73,
    "x2": 248.29,
    "y2": 711.96
  },
  {
    "x1": 241.31,
    "y1": 324.78,
    "x2": 241.31,
    "y2": 711.96
  },
  {
    "x1": 243.63,
    "y1": 324.78,
    "x2": 243.63,
    "y2": 711.96
  },
  {
    "x1": 243.44,
    "y1": 324.97,
    "x2": 243.44,
    "y2": 711.96
  },
  {
    "x1": 243.26,
    "y1": 325.04,
    "x2": 243.26,
    "y2": 711.96
  },
  {
    "x1": 243.07,
    "y1": 325.08,
    "x2": 243.07,
    "y2": 711.96
  },
  {
    "x1": 242.89,
    "y1": 325.1,
    "x2": 242.89,
    "y2": 711.96
  },
  {
    "x1": 242.7,
    "y1": 325.12,
    "x2": 242.7,
    "y2": 711.96
  },
  {
    "x1": 242.51,
    "y1": 325.13,
    "x2": 242.51,
    "y2": 711.96
  },
  {
    "x1": 242.33,
    "y1": 325.13,
    "x2": 242.33,
    "y2": 711.96
  },
  {
    "x1": 242.14,
    "y1": 325.11,
    "x2": 242.14,
    "y2": 711.96
  },
  {
    "x1": 241.95,
    "y1": 325.09,
    "x2": 241.95,
    "y2": 711.96
  },
  {
    "x1": 241.77,
    "y1": 325.06,
    "x2": 241.77,
    "y2": 711.96
  },
  {
    "x1": 241.58,
    "y1": 325,
    "x2": 241.58,
    "y2": 711.96
  },
  {
    "x1": 241.39,
    "y1": 324.91,
    "x2": 241.39,
    "y2": 711.96
  },
  {
    "x1": 246.06,
    "y1": 324.91,
    "x2": 246.06,
    "y2": 711.96
  },
  {
    "x1": 246.24,
    "y1": 325,
    "x2": 246.24,
    "y2": 711.96
  },
  {
    "x1": 246.43,
    "y1": 325.06,
    "x2": 246.43,
    "y2": 711.96
  },
  {
    "x1": 246.61,
    "y1": 325.09,
    "x2": 246.61,
    "y2": 711.96
  },
  {
    "x1": 246.8,
    "y1": 325.11,
    "x2": 246.8,
    "y2": 711.96
  },
  {
    "x1": 246.99,
    "y1": 325.13,
    "x2": 246.99,
    "y2": 711.96
  },
  {
    "x1": 247.17,
    "y1": 325.13,
    "x2": 247.17,
    "y2": 711.96
  },
  {
    "x1": 247.36,
    "y1": 325.12,
    "x2": 247.36,
    "y2": 711.96
  },
  {
    "x1": 247.55,
    "y1": 325.1,
    "x2": 247.55,
    "y2": 711.96
  },
  {
    "x1": 247.73,
    "y1": 325.08,
    "x2": 247.73,
    "y2": 711.96
  },
  {
    "x1": 247.92,
    "y1": 325.04,
    "x2": 247.92,
    "y2": 711.96
  },
  {
    "x1": 248.11,
    "y1": 324.97,
    "x2": 248.11,
    "y2": 711.96
  },
  {
    "x1": 250.72,
    "y1": 324.91,
    "x2": 250.72,
    "y2": 711.96
  },
  {
    "x1": 250.9,
    "y1": 325,
    "x2": 250.9,
    "y2": 711.96
  },
  {
    "x1": 251.09,
    "y1": 325.06,
    "x2": 251.09,
    "y2": 711.96
  },
  {
    "x1": 251.28,
    "y1": 325.09,
    "x2": 251.28,
    "y2": 711.96
  },
  {
    "x1": 251.46,
    "y1": 325.11,
    "x2": 251.46,
    "y2": 711.96
  },
  {
    "x1": 251.65,
    "y1": 325.13,
    "x2": 251.65,
    "y2": 711.96
  },
  {
    "x1": 251.84,
    "y1": 325.13,
    "x2": 251.84,
    "y2": 711.96
  },
  {
    "x1": 252.02,
    "y1": 325.12,
    "x2": 252.02,
    "y2": 711.96
  },
  {
    "x1": 252.21,
    "y1": 325.1,
    "x2": 252.21,
    "y2": 711.96
  },
  {
    "x1": 252.39,
    "y1": 325.08,
    "x2": 252.39,
    "y2": 711.96
  },
  {
    "x1": 252.58,
    "y1": 325.04,
    "x2": 252.58,
    "y2": 711.96
  },
  {
    "x1": 252.77,
    "y1": 324.97,
    "x2": 252.77,
    "y2": 711.96
  },
  {
    "x1": 260.04,
    "y1": 324.91,
    "x2": 260.04,
    "y2": 711.96
  },
  {
    "x1": 260.23,
    "y1": 325,
    "x2": 260.23,
    "y2": 711.96
  },
  {
    "x1": 260.41,
    "y1": 325.06,
    "x2": 260.41,
    "y2": 711.96
  },
  {
    "x1": 260.6,
    "y1": 325.09,
    "x2": 260.6,
    "y2": 711.96
  },
  {
    "x1": 260.78,
    "y1": 325.11,
    "x2": 260.78,
    "y2": 711.96
  },
  {
    "x1": 260.97,
    "y1": 325.13,
    "x2": 260.97,
    "y2": 711.96
  },
  {
    "x1": 261.16,
    "y1": 325.13,
    "x2": 261.16,
    "y2": 711.96
  },
  {
    "x1": 261.34,
    "y1": 325.12,
    "x2": 261.34,
    "y2": 711.96
  },
  {
    "x1": 261.53,
    "y1": 325.1,
    "x2": 261.53,
    "y2": 711.96
  },
  {
    "x1": 261.72,
    "y1": 325.08,
    "x2": 261.72,
    "y2": 711.96
  },
  {
    "x1": 261.9,
    "y1": 325.04,
    "x2": 261.9,
    "y2": 711.96
  },
  {
    "x1": 262.09,
    "y1": 324.97,
    "x2": 262.09,
    "y2": 711.96
  },
  {
    "x1": 264.7,
    "y1": 324.91,
    "x2": 264.7,
    "y2": 711.96
  },
  {
    "x1": 264.89,
    "y1": 325,
    "x2": 264.89,
    "y2": 711.96
  },
  {
    "x1": 265.07,
    "y1": 325.06,
    "x2": 265.07,
    "y2": 711.96
  },
  {
    "x1": 265.26,
    "y1": 325.09,
    "x2": 265.26,
    "y2": 711.96
  },
  {
    "x1": 265.45,
    "y1": 325.11,
    "x2": 265.45,
    "y2": 711.96
  },
  {
    "x1": 265.63,
    "y1": 325.13,
    "x2": 265.63,
    "y2": 711.96
  },
  {
    "x1": 265.82,
    "y1": 325.13,
    "x2": 265.82,
    "y2": 711.96
  },
  {
    "x1": 266,
    "y1": 325.12,
    "x2": 266,
    "y2": 711.96
  },
  {
    "x1": 266.19,
    "y1": 325.1,
    "x2": 266.19,
    "y2": 711.96
  },
  {
    "x1": 266.38,
    "y1": 325.08,
    "x2": 266.38,
    "y2": 711.96
  },
  {
    "x1": 266.56,
    "y1": 325.04,
    "x2": 266.56,
    "y2": 711.96
  },
  {
    "x1": 266.75,
    "y1": 324.97,
    "x2": 266.75,
    "y2": 711.96
  },
  {
    "x1": 269.36,
    "y1": 324.91,
    "x2": 269.36,
    "y2": 711.96
  },
  {
    "x1": 269.55,
    "y1": 325,
    "x2": 269.55,
    "y2": 711.96
  },
  {
    "x1": 269.73,
    "y1": 325.06,
    "x2": 269.73,
    "y2": 711.96
  },
  {
    "x1": 269.92,
    "y1": 325.09,
    "x2": 269.92,
    "y2": 711.96
  },
  {
    "x1": 270.11,
    "y1": 325.11,
    "x2": 270.11,
    "y2": 711.96
  },
  {
    "x1": 270.29,
    "y1": 325.13,
    "x2": 270.29,
    "y2": 711.96
  },
  {
    "x1": 270.48,
    "y1": 325.13,
    "x2": 270.48,
    "y2": 711.96
  },
  {
    "x1": 270.67,
    "y1": 325.12,
    "x2": 270.67,
    "y2": 711.96
  },
  {
    "x1": 270.85,
    "y1": 325.1,
    "x2": 270.85,
    "y2": 711.96
  },
  {
    "x1": 271.04,
    "y1": 325.08,
    "x2": 271.04,
    "y2": 711.96
  },
  {
    "x1": 271.22,
    "y1": 325.04,
    "x2": 271.22,
    "y2": 711.96
  },
  {
    "x1": 271.41,
    "y1": 324.97,
    "x2": 271.41,
    "y2": 711.96
  },
  {
    "x1": 296,
    "y1": 325.28,
    "x2": 296,
    "y2": 711.96
  },
  {
    "x1": 295.03,
    "y1": 325.28,
    "x2": 295.03,
    "y2": 711.96
  },
  {
    "x1": 306.23,
    "y1": 325.28,
    "x2": 306.23,
    "y2": 711.96
  },
  {
    "x1": 305.26,
    "y1": 325.28,
    "x2": 305.26,
    "y2": 711.96
  },
  {
    "x1": 316.46,
    "y1": 325.28,
    "x2": 316.46,
    "y2": 711.96
  },
  {
    "x1": 315.49,
    "y1": 325.28,
    "x2": 315.49,
    "y2": 711.96
  },
  {
    "x1": 390.17,
    "y1": 411.41,
    "x2": 390.17,
    "y2": 711.96
  },
  {
    "x1": 408.09,
    "y1": 190.28,
    "x2": 408.09,
    "y2": 722.11
  },
  {
    "x1": 406.75,
    "y1": 190.28,
    "x2": 406.75,
    "y2": 722.11
  },
  {
    "x1": 226.95,
    "y1": 190.28,
    "x2": 226.95,
    "y2": 722.45
  },
  {
    "x1": 225.61,
    "y1": 190.28,
    "x2": 225.61,
    "y2": 722.45
  },
  {
    "x1": 445.29,
    "y1": 277.27,
    "x2": 445.29,
    "y2": 727.58
  },
  {
    "x1": 606.46,
    "y1": 311.07,
    "x2": 606.46,
    "y2": 761.39
  },
  {
    "x1": 599.68,
    "y1": 316.14,
    "x2": 599.68,
    "y2": 766.46
  },
  {
    "x1": 110.77,
    "y1": 183.63,
    "x2": 110.77,
    "y2": 764.33
  },
  {
    "x1": 397.59,
    "y1": 179.79,
    "x2": 397.59,
    "y2": 711.96
  },
  {
    "x1": 137.01,
    "y1": 790.57,
    "x2": 110.77,
    "y2": 764.33
  },
  {
    "x1": 123.89,
    "y1": 757.73,
    "x2": 123.89,
    "y2": 777.45
  },
  {
    "x1": 191.09,
    "y1": 770.85,
    "x2": 191.09,
    "y2": 790.57
  },
  {
    "x1": 407.41,
    "y1": 770.85,
    "x2": 407.41,
    "y2": 790.57
  },
  {
    "x1": 353.33,
    "y1": 770.85,
    "x2": 353.33,
    "y2": 790.57
  },
  {
    "x1": 299.25,
    "y1": 770.85,
    "x2": 299.25,
    "y2": 790.57
  },
  {
    "x1": 245.17,
    "y1": 770.85,
    "x2": 245.17,
    "y2": 790.57
  },
  {
    "x1": 461.49,
    "y1": 770.85,
    "x2": 461.49,
    "y2": 790.57
  },
  {
    "x1": 137.01,
    "y1": 583.85,
    "x2": 110.77,
    "y2": 557.61
  },
  {
    "x1": 137.01,
    "y1": 615.02,
    "x2": 110.77,
    "y2": 588.78
  },
  {
    "x1": 123.89,
    "y1": 570.73,
    "x2": 123.89,
    "y2": 601.9
  },
  {
    "x1": 123.89,
    "y1": 508.4,
    "x2": 123.89,
    "y2": 539.57
  },
  {
    "x1": 137.01,
    "y1": 552.69,
    "x2": 110.77,
    "y2": 526.45
  },
  {
    "x1": 137.01,
    "y1": 521.52,
    "x2": 110.77,
    "y2": 495.28
  },
  {
    "x1": 123.89,
    "y1": 633.06,
    "x2": 123.89,
    "y2": 664.23
  },
  {
    "x1": 137.01,
    "y1": 646.18,
    "x2": 110.77,
    "y2": 619.94
  },
  {
    "x1": 137.01,
    "y1": 552.69,
    "x2": 191.09,
    "y2": 552.69
  },
  {
    "x1": 164.05,
    "y1": 552.69,
    "x2": 164.05,
    "y2": 583.85
  },
  {
    "x1": 137.01,
    "y1": 583.85,
    "x2": 191.09,
    "y2": 583.85
  },
  {
    "x1": 137.01,
    "y1": 521.52,
    "x2": 191.09,
    "y2": 521.52
  },
  {
    "x1": 164.05,
    "y1": 490.36,
    "x2": 164.05,
    "y2": 521.52
  },
  {
    "x1": 137.01,
    "y1": 490.36,
    "x2": 191.09,
    "y2": 490.36
  },
  {
    "x1": 137.01,
    "y1": 646.18,
    "x2": 191.09,
    "y2": 646.18
  },
  {
    "x1": 164.05,
    "y1": 615.02,
    "x2": 164.05,
    "y2": 646.18
  },
  {
    "x1": 137.01,
    "y1": 615.02,
    "x2": 191.09,
    "y2": 615.02
  },
  {
    "x1": 397.59,
    "y1": 625.39,
    "x2": 226.95,
    "y2": 625.39
  },
  {
    "x1": 397.59,
    "y1": 619.97,
    "x2": 226.95,
    "y2": 619.97
  },
  {
    "x1": 397.59,
    "y1": 512.17,
    "x2": 226.95,
    "y2": 512.17
  },
  {
    "x1": 397.59,
    "y1": 517.6,
    "x2": 226.95,
    "y2": 517.6
  },
  {
    "x1": 408.09,
    "y1": 639.81,
    "x2": 408.7,
    "y2": 640.42
  },
  {
    "x1": 379.13,
    "y1": 629.85,
    "x2": 390.17,
    "y2": 629.85
  },
  {
    "x1": 213.15,
    "y1": 629.85,
    "x2": 223.64,
    "y2": 640.35
  },
  {
    "x1": 213.15,
    "y1": 629.85,
    "x2": 215.12,
    "y2": 629.85
  },
  {
    "x1": 318.79,
    "y1": 516.48,
    "x2": 334.48,
    "y2": 501.3
  },
  {
    "x1": 384.65,
    "y1": 638.62,
    "x2": 365.89,
    "y2": 639.57
  },
  {
    "x1": 218.4,
    "y1": 654.9,
    "x2": 38.06,
    "y2": 654.9
  },
  {
    "x1": 48.14,
    "y1": 652.16,
    "x2": 50.1,
    "y2": 652.16
  },
  {
    "x1": 50.1,
    "y1": 652.16,
    "x2": 49.12,
    "y2": 654.9
  },
  {
    "x1": 48.14,
    "y1": 652.16,
    "x2": 49.12,
    "y2": 654.9
  },
  {
    "x1": 38.06,
    "y1": 653.91,
    "x2": 35.32,
    "y2": 654.9
  },
  {
    "x1": 38.06,
    "y1": 655.88,
    "x2": 35.32,
    "y2": 654.9
  },
  {
    "x1": 38.06,
    "y1": 653.91,
    "x2": 38.06,
    "y2": 655.88
  },
  {
    "x1": 218.4,
    "y1": 664.99,
    "x2": 44.35,
    "y2": 664.99
  },
  {
    "x1": 445.29,
    "y1": 727.58,
    "x2": 599.68,
    "y2": 766.46
  },
  {
    "x1": 137.01,
    "y1": 708.51,
    "x2": 110.77,
    "y2": 682.28
  },
  {
    "x1": 137.01,
    "y1": 739.68,
    "x2": 110.77,
    "y2": 713.44
  },
  {
    "x1": 123.89,
    "y1": 695.4,
    "x2": 123.89,
    "y2": 726.56
  },
  {
    "x1": 137.01,
    "y1": 770.85,
    "x2": 110.77,
    "y2": 744.61
  },
  {
    "x1": 137.01,
    "y1": 677.35,
    "x2": 191.09,
    "y2": 677.35
  },
  {
    "x1": 164.05,
    "y1": 677.35,
    "x2": 164.05,
    "y2": 708.51
  },
  {
    "x1": 137.01,
    "y1": 708.51,
    "x2": 191.09,
    "y2": 708.51
  },
  {
    "x1": 137.01,
    "y1": 770.85,
    "x2": 506.15,
    "y2": 770.85
  },
  {
    "x1": 164.05,
    "y1": 739.68,
    "x2": 164.05,
    "y2": 770.85
  },
  {
    "x1": 137.01,
    "y1": 739.68,
    "x2": 493.35,
    "y2": 739.68
  },
  {
    "x1": 218.13,
    "y1": 739.68,
    "x2": 218.13,
    "y2": 770.85
  },
  {
    "x1": 245.17,
    "y1": 725.08,
    "x2": 245.17,
    "y2": 739.68
  },
  {
    "x1": 299.25,
    "y1": 725.08,
    "x2": 299.25,
    "y2": 739.68
  },
  {
    "x1": 488.53,
    "y1": 739.68,
    "x2": 488.53,
    "y2": 770.85
  },
  {
    "x1": 434.45,
    "y1": 739.68,
    "x2": 434.45,
    "y2": 770.85
  },
  {
    "x1": 407.41,
    "y1": 725.08,
    "x2": 407.41,
    "y2": 739.68
  },
  {
    "x1": 353.33,
    "y1": 725.08,
    "x2": 353.33,
    "y2": 739.68
  },
  {
    "x1": 191.09,
    "y1": 725.08,
    "x2": 191.09,
    "y2": 739.68
  },
  {
    "x1": 191.09,
    "y1": 698.84,
    "x2": 425.83,
    "y2": 698.84
  },
  {
    "x1": 445.29,
    "y1": 718.3,
    "x2": 425.83,
    "y2": 698.84
  },
  {
    "x1": 317.71,
    "y1": 711.96,
    "x2": 314.31,
    "y2": 711.96
  },
  {
    "x1": 307.48,
    "y1": 711.96,
    "x2": 304.08,
    "y2": 711.96
  },
  {
    "x1": 297.25,
    "y1": 711.96,
    "x2": 293.84,
    "y2": 711.96
  },
  {
    "x1": 271.6,
    "y1": 711.96,
    "x2": 269.27,
    "y2": 711.96
  },
  {
    "x1": 266.94,
    "y1": 711.96,
    "x2": 264.61,
    "y2": 711.96
  },
  {
    "x1": 262.28,
    "y1": 711.96,
    "x2": 259.95,
    "y2": 711.96
  },
  {
    "x1": 252.95,
    "y1": 711.96,
    "x2": 250.63,
    "y2": 711.96
  },
  {
    "x1": 248.29,
    "y1": 711.96,
    "x2": 245.97,
    "y2": 711.96
  },
  {
    "x1": 243.63,
    "y1": 711.96,
    "x2": 241.31,
    "y2": 711.96
  },
  {
    "x1": 390.17,
    "y1": 711.96,
    "x2": 397.59,
    "y2": 711.96
  },
  {
    "x1": 397.59,
    "y1": 711.96,
    "x2": 406.75,
    "y2": 721.12
  },
  {
    "x1": 221.07,
    "y1": 717.91,
    "x2": 225.61,
    "y2": 722.45
  },
  {
    "x1": 215.12,
    "y1": 711.96,
    "x2": 219.54,
    "y2": 716.38
  },
  {
    "x1": 408.09,
    "y1": 685.92,
    "x2": 408.7,
    "y2": 686.52
  },
  {
    "x1": 390.17,
    "y1": 675.96,
    "x2": 379.13,
    "y2": 675.96
  },
  {
    "x1": 215.12,
    "y1": 677.93,
    "x2": 215.12,
    "y2": 711.96
  },
  {
    "x1": 213.15,
    "y1": 675.96,
    "x2": 223.64,
    "y2": 686.46
  },
  {
    "x1": 36.2,
    "y1": 674.11,
    "x2": 37.77,
    "y2": 675.3
  },
  {
    "x1": 37.77,
    "y1": 675.3,
    "x2": 35.33,
    "y2": 676.89
  },
  {
    "x1": 36.2,
    "y1": 674.11,
    "x2": 35.33,
    "y2": 676.89
  },
  {
    "x1": 599.68,
    "y1": 766.46,
    "x2": 606.46,
    "y2": 761.39
  },
  {
    "x1": 137.01,
    "y1": 677.35,
    "x2": 110.77,
    "y2": 651.11
  },
  {
    "x1": 408.7,
    "y1": 686.52,
    "x2": 408.7,
    "y2": 640.42
  },
  {
    "x1": 379.13,
    "y1": 629.85,
    "x2": 379.13,
    "y2": 675.96
  },
  {
    "x1": 223.64,
    "y1": 686.46,
    "x2": 223.64,
    "y2": 640.35
  },
  {
    "x1": 213.15,
    "y1": 629.85,
    "x2": 213.15,
    "y2": 675.96
  },
  {
    "x1": 44.35,
    "y1": 664.99,
    "x2": 36.99,
    "y2": 674.71
  },
  {
    "x1": 123.89,
    "y1": 196.75,
    "x2": 123.89,
    "y2": 227.91
  },
  {
    "x1": 493.03,
    "y1": 196.75,
    "x2": 493.03,
    "y2": 209.86
  },
  {
    "x1": 137.01,
    "y1": 209.86,
    "x2": 110.77,
    "y2": 183.63
  },
  {
    "x1": 506.15,
    "y1": 209.86,
    "x2": 479.91,
    "y2": 183.63
  },
  {
    "x1": 479.91,
    "y1": 183.63,
    "x2": 479.91,
    "y2": 209.86
  },
  {
    "x1": 390.17,
    "y1": 179.79,
    "x2": 390.17,
    "y2": 405.98
  },
  {
    "x1": 215.12,
    "y1": 179.79,
    "x2": 215.12,
    "y2": 390.73
  },
  {
    "x1": 191.09,
    "y1": 271.73,
    "x2": 191.09,
    "y2": 0.1
  },
  {
    "x1": 425.83,
    "y1": 271.73,
    "x2": 425.83,
    "y2": 0.1
  },
  {
    "x1": 408.22,
    "y1": 287.06,
    "x2": 609.56,
    "y2": 287.06
  },
  {
    "x1": 452.07,
    "y1": 272.2,
    "x2": 606.46,
    "y2": 311.07
  },
  {
    "x1": 445.29,
    "y1": 277.27,
    "x2": 599.68,
    "y2": 316.14
  },
  {
    "x1": 481.1,
    "y1": 369.46,
    "x2": 563.87,
    "y2": 390.3
  },
  {
    "x1": 481.1,
    "y1": 417.13,
    "x2": 563.87,
    "y2": 437.97
  },
  {
    "x1": 481.1,
    "y1": 375.28,
    "x2": 563.87,
    "y2": 396.12
  },
  {
    "x1": 481.1,
    "y1": 376.22,
    "x2": 563.87,
    "y2": 397.06
  },
  {
    "x1": 481.1,
    "y1": 382.04,
    "x2": 563.87,
    "y2": 402.88
  },
  {
    "x1": 481.1,
    "y1": 381.1,
    "x2": 563.87,
    "y2": 401.94
  },
  {
    "x1": 481.1,
    "y1": 392.73,
    "x2": 563.87,
    "y2": 413.58
  },
  {
    "x1": 481.1,
    "y1": 393.67,
    "x2": 563.87,
    "y2": 414.52
  },
  {
    "x1": 481.1,
    "y1": 387.86,
    "x2": 563.87,
    "y2": 408.7
  },
  {
    "x1": 481.1,
    "y1": 386.91,
    "x2": 563.87,
    "y2": 407.76
  },
  {
    "x1": 481.1,
    "y1": 404.37,
    "x2": 563.87,
    "y2": 425.21
  },
  {
    "x1": 481.1,
    "y1": 405.31,
    "x2": 563.87,
    "y2": 426.15
  },
  {
    "x1": 481.1,
    "y1": 411.13,
    "x2": 563.87,
    "y2": 431.97
  },
  {
    "x1": 481.1,
    "y1": 410.19,
    "x2": 563.87,
    "y2": 431.03
  },
  {
    "x1": 481.1,
    "y1": 398.55,
    "x2": 563.87,
    "y2": 419.39
  },
  {
    "x1": 481.1,
    "y1": 399.49,
    "x2": 563.87,
    "y2": 420.34
  },
  {
    "x1": 191.09,
    "y1": 272.2,
    "x2": 137.01,
    "y2": 272.2
  },
  {
    "x1": 191.09,
    "y1": 272.2,
    "x2": 191.09,
    "y2": 241.03
  },
  {
    "x1": 452.07,
    "y1": 272.2,
    "x2": 506.15,
    "y2": 272.2
  },
  {
    "x1": 452.07,
    "y1": 241.03,
    "x2": 452.07,
    "y2": 209.86
  },
  {
    "x1": 479.11,
    "y1": 272.2,
    "x2": 479.11,
    "y2": 241.03
  },
  {
    "x1": 218.13,
    "y1": 272.2,
    "x2": 218.13,
    "y2": 241.03
  },
  {
    "x1": 137.01,
    "y1": 241.03,
    "x2": 215.12,
    "y2": 241.03
  },
  {
    "x1": 137.01,
    "y1": 241.03,
    "x2": 110.77,
    "y2": 214.79
  },
  {
    "x1": 137.01,
    "y1": 272.2,
    "x2": 110.77,
    "y2": 245.96
  },
  {
    "x1": 137.01,
    "y1": 303.36,
    "x2": 110.77,
    "y2": 277.12
  },
  {
    "x1": 123.89,
    "y1": 259.08,
    "x2": 123.89,
    "y2": 290.24
  },
  {
    "x1": 123.89,
    "y1": 321.41,
    "x2": 123.89,
    "y2": 352.57
  },
  {
    "x1": 137.01,
    "y1": 365.69,
    "x2": 110.77,
    "y2": 339.45
  },
  {
    "x1": 137.01,
    "y1": 334.53,
    "x2": 110.77,
    "y2": 308.29
  },
  {
    "x1": 137.01,
    "y1": 459.19,
    "x2": 110.77,
    "y2": 432.95
  },
  {
    "x1": 123.89,
    "y1": 446.07,
    "x2": 123.89,
    "y2": 477.24
  },
  {
    "x1": 123.89,
    "y1": 383.74,
    "x2": 123.89,
    "y2": 414.9
  },
  {
    "x1": 137.01,
    "y1": 428.02,
    "x2": 110.77,
    "y2": 401.79
  },
  {
    "x1": 137.01,
    "y1": 396.86,
    "x2": 110.77,
    "y2": 370.62
  },
  {
    "x1": 137.01,
    "y1": 303.36,
    "x2": 191.09,
    "y2": 303.36
  },
  {
    "x1": 137.01,
    "y1": 334.53,
    "x2": 191.09,
    "y2": 334.53
  },
  {
    "x1": 137.01,
    "y1": 365.69,
    "x2": 191.09,
    "y2": 365.69
  },
  {
    "x1": 164.05,
    "y1": 303.36,
    "x2": 164.05,
    "y2": 334.53
  },
  {
    "x1": 164.05,
    "y1": 365.69,
    "x2": 164.05,
    "y2": 396.86
  },
  {
    "x1": 137.01,
    "y1": 396.86,
    "x2": 191.09,
    "y2": 396.86
  },
  {
    "x1": 137.01,
    "y1": 459.19,
    "x2": 191.09,
    "y2": 459.19
  },
  {
    "x1": 164.05,
    "y1": 428.02,
    "x2": 164.05,
    "y2": 459.19
  },
  {
    "x1": 137.01,
    "y1": 428.02,
    "x2": 191.09,
    "y2": 428.02
  },
  {
    "x1": 397.59,
    "y1": 289.69,
    "x2": 406.75,
    "y2": 297.68
  },
  {
    "x1": 215.12,
    "y1": 288.35,
    "x2": 225.61,
    "y2": 298.85
  },
  {
    "x1": 379.13,
    "y1": 411.41,
    "x2": 379.13,
    "y2": 434.87
  },
  {
    "x1": 397.59,
    "y1": 411.41,
    "x2": 226.95,
    "y2": 411.41
  },
  {
    "x1": 397.59,
    "y1": 405.98,
    "x2": 226.95,
    "y2": 405.98
  },
  {
    "x1": 390.17,
    "y1": 434.87,
    "x2": 379.13,
    "y2": 434.87
  },
  {
    "x1": 379.13,
    "y1": 388.76,
    "x2": 390.17,
    "y2": 388.76
  },
  {
    "x1": 213.15,
    "y1": 388.76,
    "x2": 215.12,
    "y2": 388.76
  },
  {
    "x1": 213.15,
    "y1": 388.76,
    "x2": 223.64,
    "y2": 399.26
  },
  {
    "x1": 213.15,
    "y1": 434.87,
    "x2": 223.64,
    "y2": 445.36
  },
  {
    "x1": 223.64,
    "y1": 445.36,
    "x2": 223.64,
    "y2": 399.26
  },
  {
    "x1": 213.15,
    "y1": 388.76,
    "x2": 213.15,
    "y2": 434.87
  },
  {
    "x1": 379.13,
    "y1": 388.76,
    "x2": 379.13,
    "y2": 405.98
  },
  {
    "x1": 408.7,
    "y1": 445.43,
    "x2": 408.7,
    "y2": 399.33
  },
  {
    "x1": 408.09,
    "y1": 444.83,
    "x2": 408.7,
    "y2": 445.43
  },
  {
    "x1": 408.09,
    "y1": 398.72,
    "x2": 408.7,
    "y2": 399.33
  },
  {
    "x1": 243.73,
    "y1": 276.53,
    "x2": 242.47,
    "y2": 324.78
  },
  {
    "x1": 243.73,
    "y1": 276.53,
    "x2": 247.13,
    "y2": 324.73
  },
  {
    "x1": 243.73,
    "y1": 276.53,
    "x2": 251.79,
    "y2": 324.78
  },
  {
    "x1": 259.78,
    "y1": 276.47,
    "x2": 270.44,
    "y2": 324.73
  },
  {
    "x1": 259.78,
    "y1": 276.47,
    "x2": 265.77,
    "y2": 324.68
  },
  {
    "x1": 259.78,
    "y1": 276.47,
    "x2": 261.11,
    "y2": 324.73
  },
  {
    "x1": 309.32,
    "y1": 276.47,
    "x2": 295.55,
    "y2": 324.78
  },
  {
    "x1": 309.32,
    "y1": 276.47,
    "x2": 305.78,
    "y2": 324.78
  },
  {
    "x1": 309.32,
    "y1": 276.47,
    "x2": 316.01,
    "y2": 324.78
  },
  {
    "x1": 397.59,
    "y1": 241.03,
    "x2": 506.15,
    "y2": 241.03
  },
  {
    "x1": 445.29,
    "y1": 277.27,
    "x2": 452.07,
    "y2": 272.2
  },
  {
    "x1": 481.1,
    "y1": 369.46,
    "x2": 481.1,
    "y2": 417.13
  },
  {
    "x1": 481.1,
    "y1": 375.28,
    "x2": 486.92,
    "y2": 370.93
  },
  {
    "x1": 481.1,
    "y1": 381.1,
    "x2": 485.97,
    "y2": 377.45
  },
  {
    "x1": 481.1,
    "y1": 386.91,
    "x2": 485.97,
    "y2": 383.27
  },
  {
    "x1": 481.1,
    "y1": 392.73,
    "x2": 485.97,
    "y2": 389.08
  },
  {
    "x1": 481.1,
    "y1": 398.55,
    "x2": 485.97,
    "y2": 394.9
  },
  {
    "x1": 481.1,
    "y1": 404.37,
    "x2": 485.97,
    "y2": 400.72
  },
  {
    "x1": 481.1,
    "y1": 410.19,
    "x2": 485.97,
    "y2": 406.54
  },
  {
    "x1": 481.1,
    "y1": 417.13,
    "x2": 487.1,
    "y2": 412.64
  },
  {
    "x1": 348.53,
    "y1": 410.39,
    "x2": 355.22,
    "y2": 417.43
  },
  {
    "x1": 218.4,
    "y1": 413.81,
    "x2": 38.06,
    "y2": 413.81
  },
  {
    "x1": 50.1,
    "y1": 416.54,
    "x2": 48.14,
    "y2": 416.54
  },
  {
    "x1": 50.1,
    "y1": 416.54,
    "x2": 49.12,
    "y2": 413.81
  },
  {
    "x1": 48.14,
    "y1": 416.54,
    "x2": 49.12,
    "y2": 413.81
  },
  {
    "x1": 38.06,
    "y1": 412.82,
    "x2": 38.06,
    "y2": 414.79
  },
  {
    "x1": 38.06,
    "y1": 414.79,
    "x2": 35.32,
    "y2": 413.81
  },
  {
    "x1": 38.06,
    "y1": 412.82,
    "x2": 35.32,
    "y2": 413.81
  },
  {
    "x1": 599.68,
    "y1": 316.14,
    "x2": 606.46,
    "y2": 311.07
  },
  {
    "x1": 563.87,
    "y1": 390.3,
    "x2": 563.87,
    "y2": 437.97
  },
  {
    "x1": 609.56,
    "y1": 288.08,
    "x2": 609.56,
    "y2": 286.11
  },
  {
    "x1": 609.56,
    "y1": 286.11,
    "x2": 612.3,
    "y2": 287.09
  },
  {
    "x1": 609.56,
    "y1": 288.08,
    "x2": 612.3,
    "y2": 287.09
  },
  {
    "x1": 390.17,
    "y1": 179.79,
    "x2": 397.59,
    "y2": 179.79
  },
  {
    "x1": 215.12,
    "y1": 179.79,
    "x2": 222.54,
    "y2": 179.79
  },
  {
    "x1": 222.54,
    "y1": 179.79,
    "x2": 222.54,
    "y2": 187.21
  },
  {
    "x1": 187.23,
    "y1": 3.97,
    "x2": 429.69,
    "y2": 3.97
  },
  {
    "x1": 215.12,
    "y1": 168.19,
    "x2": 215.12,
    "y2": 18.79
  },
  {
    "x1": 397.59,
    "y1": 168.19,
    "x2": 397.59,
    "y2": 18.79
  },
  {
    "x1": 211.25,
    "y1": 22.65,
    "x2": 401.46,
    "y2": 22.65
  },
  {
    "x1": 405.79,
    "y1": 171.59,
    "x2": 405.17,
    "y2": 172.22
  },
  {
    "x1": 416.21,
    "y1": 182.01,
    "x2": 415.58,
    "y2": 182.63
  },
  {
    "x1": 402.43,
    "y1": 174.95,
    "x2": 399.7,
    "y2": 172.22
  },
  {
    "x1": 412.85,
    "y1": 185.37,
    "x2": 415.58,
    "y2": 188.1
  },
  {
    "x1": 402.43,
    "y1": 174.95,
    "x2": 412.85,
    "y2": 185.37
  },
  {
    "x1": 218.19,
    "y1": 205.47,
    "x2": 38.06,
    "y2": 205.47
  },
  {
    "x1": 38.06,
    "y1": 204.45,
    "x2": 35.32,
    "y2": 205.43
  },
  {
    "x1": 38.06,
    "y1": 206.41,
    "x2": 35.32,
    "y2": 205.43
  },
  {
    "x1": 38.06,
    "y1": 204.45,
    "x2": 38.06,
    "y2": 206.41
  },
  {
    "x1": 397.59,
    "y1": 179.79,
    "x2": 408.09,
    "y2": 190.28
  },
  {
    "x1": 215.12,
    "y1": 179.79,
    "x2": 225.61,
    "y2": 190.28
  }
],
  polylines: [
  {
    "vertices": [
      {
        "x": 506.15,
        "y": 742.9
      },
      {
        "x": 506.15,
        "y": 790.57
      },
      {
        "x": 137.01,
        "y": 790.57
      },
      {
        "x": 137.01,
        "y": 209.86
      },
      {
        "x": 215.12,
        "y": 209.86
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 445.29,
        "y": 725.08
      },
      {
        "x": 191.09,
        "y": 725.08
      },
      {
        "x": 191.09,
        "y": 272.2
      },
      {
        "x": 215.12,
        "y": 272.2
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 232.64,
        "y": 621.58
      },
      {
        "x": 235.62,
        "y": 621.58
      },
      {
        "x": 235.62,
        "y": 623.72
      },
      {
        "x": 232.64,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 226.95,
        "y": 621.58
      },
      {
        "x": 229.27,
        "y": 621.58
      },
      {
        "x": 229.27,
        "y": 623.72
      },
      {
        "x": 226.95,
        "y": 623.72
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 245.33,
        "y": 621.58
      },
      {
        "x": 248.31,
        "y": 621.58
      },
      {
        "x": 248.31,
        "y": 623.72
      },
      {
        "x": 245.33,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 238.98,
        "y": 621.58
      },
      {
        "x": 241.96,
        "y": 621.58
      },
      {
        "x": 241.96,
        "y": 623.72
      },
      {
        "x": 238.98,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 251.67,
        "y": 621.58
      },
      {
        "x": 254.65,
        "y": 621.58
      },
      {
        "x": 254.65,
        "y": 623.72
      },
      {
        "x": 251.67,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 258.01,
        "y": 621.58
      },
      {
        "x": 261,
        "y": 621.58
      },
      {
        "x": 261,
        "y": 623.72
      },
      {
        "x": 258.01,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 264.36,
        "y": 621.58
      },
      {
        "x": 267.34,
        "y": 621.58
      },
      {
        "x": 267.34,
        "y": 623.72
      },
      {
        "x": 264.36,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 270.7,
        "y": 621.58
      },
      {
        "x": 273.68,
        "y": 621.58
      },
      {
        "x": 273.68,
        "y": 623.72
      },
      {
        "x": 270.7,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 283.39,
        "y": 621.58
      },
      {
        "x": 286.37,
        "y": 621.58
      },
      {
        "x": 286.37,
        "y": 623.72
      },
      {
        "x": 283.39,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 277.05,
        "y": 621.58
      },
      {
        "x": 280.03,
        "y": 621.58
      },
      {
        "x": 280.03,
        "y": 623.72
      },
      {
        "x": 277.05,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 296.08,
        "y": 621.58
      },
      {
        "x": 299.06,
        "y": 621.58
      },
      {
        "x": 299.06,
        "y": 623.72
      },
      {
        "x": 296.08,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 289.74,
        "y": 621.58
      },
      {
        "x": 292.72,
        "y": 621.58
      },
      {
        "x": 292.72,
        "y": 623.72
      },
      {
        "x": 289.74,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 308.77,
        "y": 621.58
      },
      {
        "x": 311.75,
        "y": 621.58
      },
      {
        "x": 311.75,
        "y": 623.72
      },
      {
        "x": 308.77,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 302.43,
        "y": 621.58
      },
      {
        "x": 305.41,
        "y": 621.58
      },
      {
        "x": 305.41,
        "y": 623.72
      },
      {
        "x": 302.43,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 321.46,
        "y": 621.58
      },
      {
        "x": 324.44,
        "y": 621.58
      },
      {
        "x": 324.44,
        "y": 623.72
      },
      {
        "x": 321.46,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 315.12,
        "y": 621.58
      },
      {
        "x": 318.1,
        "y": 621.58
      },
      {
        "x": 318.1,
        "y": 623.72
      },
      {
        "x": 315.12,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 334.15,
        "y": 621.58
      },
      {
        "x": 337.13,
        "y": 621.58
      },
      {
        "x": 337.13,
        "y": 623.72
      },
      {
        "x": 334.15,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 327.8,
        "y": 621.58
      },
      {
        "x": 330.78,
        "y": 621.58
      },
      {
        "x": 330.78,
        "y": 623.72
      },
      {
        "x": 327.8,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 346.84,
        "y": 621.58
      },
      {
        "x": 349.82,
        "y": 621.58
      },
      {
        "x": 349.82,
        "y": 623.72
      },
      {
        "x": 346.84,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 340.49,
        "y": 621.58
      },
      {
        "x": 343.47,
        "y": 621.58
      },
      {
        "x": 343.47,
        "y": 623.72
      },
      {
        "x": 340.49,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 359.53,
        "y": 621.58
      },
      {
        "x": 362.51,
        "y": 621.58
      },
      {
        "x": 362.51,
        "y": 623.72
      },
      {
        "x": 359.53,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 353.18,
        "y": 621.58
      },
      {
        "x": 356.16,
        "y": 621.58
      },
      {
        "x": 356.16,
        "y": 623.72
      },
      {
        "x": 353.18,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 365.87,
        "y": 621.58
      },
      {
        "x": 368.85,
        "y": 621.58
      },
      {
        "x": 368.85,
        "y": 623.72
      },
      {
        "x": 365.87,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 372.22,
        "y": 621.58
      },
      {
        "x": 375.2,
        "y": 621.58
      },
      {
        "x": 375.2,
        "y": 623.72
      },
      {
        "x": 372.22,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 378.56,
        "y": 621.58
      },
      {
        "x": 381.54,
        "y": 621.58
      },
      {
        "x": 381.54,
        "y": 623.72
      },
      {
        "x": 378.56,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 384.9,
        "y": 621.58
      },
      {
        "x": 387.89,
        "y": 621.58
      },
      {
        "x": 387.89,
        "y": 623.72
      },
      {
        "x": 384.9,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 391.25,
        "y": 621.58
      },
      {
        "x": 394.23,
        "y": 621.58
      },
      {
        "x": 394.23,
        "y": 623.72
      },
      {
        "x": 391.25,
        "y": 623.72
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 391.25,
        "y": 513.78
      },
      {
        "x": 394.23,
        "y": 513.78
      },
      {
        "x": 394.23,
        "y": 515.92
      },
      {
        "x": 391.25,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 384.9,
        "y": 513.78
      },
      {
        "x": 387.89,
        "y": 513.78
      },
      {
        "x": 387.89,
        "y": 515.92
      },
      {
        "x": 384.9,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 378.56,
        "y": 513.78
      },
      {
        "x": 381.54,
        "y": 513.78
      },
      {
        "x": 381.54,
        "y": 515.92
      },
      {
        "x": 378.56,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 365.87,
        "y": 513.78
      },
      {
        "x": 368.85,
        "y": 513.78
      },
      {
        "x": 368.85,
        "y": 515.92
      },
      {
        "x": 365.87,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 372.22,
        "y": 513.78
      },
      {
        "x": 375.2,
        "y": 513.78
      },
      {
        "x": 375.2,
        "y": 515.92
      },
      {
        "x": 372.22,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 353.18,
        "y": 513.78
      },
      {
        "x": 356.16,
        "y": 513.78
      },
      {
        "x": 356.16,
        "y": 515.92
      },
      {
        "x": 353.18,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 359.53,
        "y": 513.78
      },
      {
        "x": 362.51,
        "y": 513.78
      },
      {
        "x": 362.51,
        "y": 515.92
      },
      {
        "x": 359.53,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 346.84,
        "y": 513.78
      },
      {
        "x": 349.82,
        "y": 513.78
      },
      {
        "x": 349.82,
        "y": 515.92
      },
      {
        "x": 346.84,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 339.51,
        "y": 513.78
      },
      {
        "x": 342.49,
        "y": 513.78
      },
      {
        "x": 342.49,
        "y": 515.92
      },
      {
        "x": 339.51,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 326.82,
        "y": 513.78
      },
      {
        "x": 329.8,
        "y": 513.78
      },
      {
        "x": 329.8,
        "y": 515.92
      },
      {
        "x": 326.82,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 333.16,
        "y": 513.78
      },
      {
        "x": 336.14,
        "y": 513.78
      },
      {
        "x": 336.14,
        "y": 515.92
      },
      {
        "x": 333.16,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 314.13,
        "y": 513.78
      },
      {
        "x": 317.11,
        "y": 513.78
      },
      {
        "x": 317.11,
        "y": 515.92
      },
      {
        "x": 314.13,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 320.47,
        "y": 513.78
      },
      {
        "x": 323.45,
        "y": 513.78
      },
      {
        "x": 323.45,
        "y": 515.92
      },
      {
        "x": 320.47,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 301.44,
        "y": 513.78
      },
      {
        "x": 304.42,
        "y": 513.78
      },
      {
        "x": 304.42,
        "y": 515.92
      },
      {
        "x": 301.44,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 307.78,
        "y": 513.78
      },
      {
        "x": 310.76,
        "y": 513.78
      },
      {
        "x": 310.76,
        "y": 515.92
      },
      {
        "x": 307.78,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 277.05,
        "y": 513.78
      },
      {
        "x": 280.03,
        "y": 513.78
      },
      {
        "x": 280.03,
        "y": 515.92
      },
      {
        "x": 277.05,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 295.09,
        "y": 513.78
      },
      {
        "x": 298.08,
        "y": 513.78
      },
      {
        "x": 298.08,
        "y": 515.92
      },
      {
        "x": 295.09,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 264.36,
        "y": 513.78
      },
      {
        "x": 267.34,
        "y": 513.78
      },
      {
        "x": 267.34,
        "y": 515.92
      },
      {
        "x": 264.36,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 270.7,
        "y": 513.78
      },
      {
        "x": 273.68,
        "y": 513.78
      },
      {
        "x": 273.68,
        "y": 515.92
      },
      {
        "x": 270.7,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 258.01,
        "y": 513.78
      },
      {
        "x": 261,
        "y": 513.78
      },
      {
        "x": 261,
        "y": 515.92
      },
      {
        "x": 258.01,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 251.67,
        "y": 513.78
      },
      {
        "x": 254.65,
        "y": 513.78
      },
      {
        "x": 254.65,
        "y": 515.92
      },
      {
        "x": 251.67,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 238.98,
        "y": 513.78
      },
      {
        "x": 241.96,
        "y": 513.78
      },
      {
        "x": 241.96,
        "y": 515.92
      },
      {
        "x": 238.98,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 245.33,
        "y": 513.78
      },
      {
        "x": 248.31,
        "y": 513.78
      },
      {
        "x": 248.31,
        "y": 515.92
      },
      {
        "x": 245.33,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 226.95,
        "y": 513.78
      },
      {
        "x": 229.27,
        "y": 513.78
      },
      {
        "x": 229.27,
        "y": 515.92
      },
      {
        "x": 226.95,
        "y": 515.92
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 232.64,
        "y": 513.78
      },
      {
        "x": 235.62,
        "y": 513.78
      },
      {
        "x": 235.62,
        "y": 515.92
      },
      {
        "x": 232.64,
        "y": 515.92
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 561.46,
        "y": 611.2
      },
      {
        "x": 588,
        "y": 611.2
      },
      {
        "x": 588,
        "y": 616.5
      },
      {
        "x": 561.46,
        "y": 616.5
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 585.96,
        "y": 633.22
      },
      {
        "x": 585.96,
        "y": 649.13
      },
      {
        "x": 581.88,
        "y": 649.13
      },
      {
        "x": 581.88,
        "y": 633.22
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 248.44,
        "y": 112.98
      },
      {
        "x": 263.69,
        "y": 112.98
      },
      {
        "x": 263.69,
        "y": 270.69
      },
      {
        "x": 248.44,
        "y": 270.69
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 230.67,
        "y": 123.24
      },
      {
        "x": 245.03,
        "y": 123.24
      },
      {
        "x": 245.03,
        "y": 270.65
      },
      {
        "x": 230.67,
        "y": 270.65
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 274.4,
        "y": 26.36
      },
      {
        "x": 343.52,
        "y": 26.36
      },
      {
        "x": 343.52,
        "y": 270.67
      },
      {
        "x": 274.4,
        "y": 270.67
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 232.64,
        "y": 407.6
      },
      {
        "x": 235.62,
        "y": 407.6
      },
      {
        "x": 235.62,
        "y": 409.73
      },
      {
        "x": 232.64,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 226.95,
        "y": 407.6
      },
      {
        "x": 229.27,
        "y": 407.6
      },
      {
        "x": 229.27,
        "y": 409.73
      },
      {
        "x": 226.95,
        "y": 409.73
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 245.33,
        "y": 407.6
      },
      {
        "x": 248.31,
        "y": 407.6
      },
      {
        "x": 248.31,
        "y": 409.73
      },
      {
        "x": 245.33,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 238.98,
        "y": 407.6
      },
      {
        "x": 241.96,
        "y": 407.6
      },
      {
        "x": 241.96,
        "y": 409.73
      },
      {
        "x": 238.98,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 258.01,
        "y": 407.6
      },
      {
        "x": 261,
        "y": 407.6
      },
      {
        "x": 261,
        "y": 409.73
      },
      {
        "x": 258.01,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 251.67,
        "y": 407.6
      },
      {
        "x": 254.65,
        "y": 407.6
      },
      {
        "x": 254.65,
        "y": 409.73
      },
      {
        "x": 251.67,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 270.7,
        "y": 407.6
      },
      {
        "x": 273.68,
        "y": 407.6
      },
      {
        "x": 273.68,
        "y": 409.73
      },
      {
        "x": 270.7,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 264.36,
        "y": 407.6
      },
      {
        "x": 267.34,
        "y": 407.6
      },
      {
        "x": 267.34,
        "y": 409.73
      },
      {
        "x": 264.36,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 283.39,
        "y": 407.6
      },
      {
        "x": 286.37,
        "y": 407.6
      },
      {
        "x": 286.37,
        "y": 409.73
      },
      {
        "x": 283.39,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 277.05,
        "y": 407.6
      },
      {
        "x": 280.03,
        "y": 407.6
      },
      {
        "x": 280.03,
        "y": 409.73
      },
      {
        "x": 277.05,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 307.78,
        "y": 407.6
      },
      {
        "x": 310.76,
        "y": 407.6
      },
      {
        "x": 310.76,
        "y": 409.73
      },
      {
        "x": 307.78,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 301.44,
        "y": 407.6
      },
      {
        "x": 304.42,
        "y": 407.6
      },
      {
        "x": 304.42,
        "y": 409.73
      },
      {
        "x": 301.44,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 320.47,
        "y": 407.6
      },
      {
        "x": 323.45,
        "y": 407.6
      },
      {
        "x": 323.45,
        "y": 409.73
      },
      {
        "x": 320.47,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 314.13,
        "y": 407.6
      },
      {
        "x": 317.11,
        "y": 407.6
      },
      {
        "x": 317.11,
        "y": 409.73
      },
      {
        "x": 314.13,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 333.16,
        "y": 407.6
      },
      {
        "x": 336.14,
        "y": 407.6
      },
      {
        "x": 336.14,
        "y": 409.73
      },
      {
        "x": 333.16,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 326.82,
        "y": 407.6
      },
      {
        "x": 329.8,
        "y": 407.6
      },
      {
        "x": 329.8,
        "y": 409.73
      },
      {
        "x": 326.82,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 345.85,
        "y": 407.6
      },
      {
        "x": 348.83,
        "y": 407.6
      },
      {
        "x": 348.83,
        "y": 409.73
      },
      {
        "x": 345.85,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 339.51,
        "y": 407.6
      },
      {
        "x": 342.49,
        "y": 407.6
      },
      {
        "x": 342.49,
        "y": 409.73
      },
      {
        "x": 339.51,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 346.84,
        "y": 407.6
      },
      {
        "x": 349.82,
        "y": 407.6
      },
      {
        "x": 349.82,
        "y": 409.73
      },
      {
        "x": 346.84,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 352.2,
        "y": 407.6
      },
      {
        "x": 355.18,
        "y": 407.6
      },
      {
        "x": 355.18,
        "y": 409.73
      },
      {
        "x": 352.2,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 359.53,
        "y": 407.6
      },
      {
        "x": 362.51,
        "y": 407.6
      },
      {
        "x": 362.51,
        "y": 409.73
      },
      {
        "x": 359.53,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 353.18,
        "y": 407.6
      },
      {
        "x": 356.16,
        "y": 407.6
      },
      {
        "x": 356.16,
        "y": 409.73
      },
      {
        "x": 353.18,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 372.22,
        "y": 407.6
      },
      {
        "x": 375.2,
        "y": 407.6
      },
      {
        "x": 375.2,
        "y": 409.73
      },
      {
        "x": 372.22,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 365.87,
        "y": 407.6
      },
      {
        "x": 368.85,
        "y": 407.6
      },
      {
        "x": 368.85,
        "y": 409.73
      },
      {
        "x": 365.87,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 378.56,
        "y": 407.6
      },
      {
        "x": 381.54,
        "y": 407.6
      },
      {
        "x": 381.54,
        "y": 409.73
      },
      {
        "x": 378.56,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 384.9,
        "y": 407.6
      },
      {
        "x": 387.89,
        "y": 407.6
      },
      {
        "x": 387.89,
        "y": 409.73
      },
      {
        "x": 384.9,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 391.25,
        "y": 407.6
      },
      {
        "x": 394.23,
        "y": 407.6
      },
      {
        "x": 394.23,
        "y": 409.73
      },
      {
        "x": 391.25,
        "y": 409.73
      }
    ],
    "closed": true
  },
  {
    "vertices": [
      {
        "x": 408.09,
        "y": 209.86
      },
      {
        "x": 506.15,
        "y": 209.86
      },
      {
        "x": 506.15,
        "y": 285.81
      }
    ],
    "closed": false
  },
  {
    "vertices": [
      {
        "x": 408.09,
        "y": 272.2
      },
      {
        "x": 452.07,
        "y": 272.2
      }
    ],
    "closed": false
  }
],
  circles: [
  {
    "cx": 384.65,
    "cy": 638.62,
    "r": 3.33
  },
  {
    "cx": 583.92,
    "cy": 633.22,
    "r": 2.04
  },
  {
    "cx": 384.65,
    "cy": 667.2,
    "r": 3.33
  },
  {
    "cx": 384.65,
    "cy": 426.11,
    "r": 3.33
  },
  {
    "cx": 384.65,
    "cy": 397.53,
    "r": 3.33
  }
],
  arcs: [
  {
    "cx": 295.53,
    "cy": 516.67,
    "r": 2.81,
    "startAngle": 359.09,
    "endAngle": 357.79
  },
  {
    "cx": 295.53,
    "cy": 516.67,
    "r": 2.45,
    "startAngle": 359.21,
    "endAngle": 357.67
  },
  {
    "cx": 295.53,
    "cy": 516.67,
    "r": 2.14,
    "startAngle": 359.36,
    "endAngle": 357.53
  },
  {
    "cx": 305.76,
    "cy": 516.67,
    "r": 2.45,
    "startAngle": 359.21,
    "endAngle": 357.67
  },
  {
    "cx": 305.76,
    "cy": 516.67,
    "r": 2.81,
    "startAngle": 359.09,
    "endAngle": 357.79
  },
  {
    "cx": 305.76,
    "cy": 516.67,
    "r": 2.14,
    "startAngle": 359.36,
    "endAngle": 357.53
  },
  {
    "cx": 315.99,
    "cy": 516.67,
    "r": 2.14,
    "startAngle": 359.36,
    "endAngle": 357.53
  },
  {
    "cx": 315.99,
    "cy": 516.67,
    "r": 2.81,
    "startAngle": 359.09,
    "endAngle": 357.79
  },
  {
    "cx": 315.99,
    "cy": 516.67,
    "r": 2.45,
    "startAngle": 359.21,
    "endAngle": 357.67
  },
  {
    "cx": 407.42,
    "cy": 721.63,
    "r": 0.82,
    "startAngle": 354.34,
    "endAngle": 356.24
  },
  {
    "cx": 226.28,
    "cy": 721.97,
    "r": 0.82,
    "startAngle": 354.34,
    "endAngle": 356.24
  },
  {
    "cx": 407.42,
    "cy": 298.37,
    "r": 0.82,
    "startAngle": 354.34,
    "endAngle": 356.24
  },
  {
    "cx": 226.28,
    "cy": 298.37,
    "r": 0.82,
    "startAngle": 354.34,
    "endAngle": 356.24
  },
  {
    "cx": 407.42,
    "cy": 189.8,
    "r": 0.82,
    "startAngle": 354.34,
    "endAngle": 356.24
  },
  {
    "cx": 226.28,
    "cy": 189.8,
    "r": 0.82,
    "startAngle": 354.34,
    "endAngle": 356.24
  }
],
  ellipses: [
  {
    "cx": 218.4,
    "cy": 642.08,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 218.4,
    "cy": 652.18,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 218.4,
    "cy": 662.27,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 500.3,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 518.14,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 553.83,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 535.99,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 607.36,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 625.2,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 589.51,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 571.67,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 714.41,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": -1.91,
    "endAngle": 2.21
  },
  {
    "cx": 218.4,
    "cy": 672.37,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 696.57,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 678.72,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 2.56,
    "endAngle": 4.01
  },
  {
    "cx": 316.01,
    "cy": 324.78,
    "rx": 1.7,
    "ry": 0.52,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 305.78,
    "cy": 324.78,
    "rx": 1.7,
    "ry": 0.52,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 295.55,
    "cy": 324.78,
    "rx": 1.7,
    "ry": 0.52,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 270.44,
    "cy": 324.78,
    "rx": 1.16,
    "ry": 0.35,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 265.77,
    "cy": 324.78,
    "rx": 1.16,
    "ry": 0.35,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 261.11,
    "cy": 324.73,
    "rx": 1.16,
    "ry": 0.35,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 251.79,
    "cy": 324.78,
    "rx": 1.16,
    "ry": 0.35,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 247.13,
    "cy": 324.73,
    "rx": 1.16,
    "ry": 0.35,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 242.47,
    "cy": 324.78,
    "rx": 1.16,
    "ry": 0.35,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 401.51,
    "cy": 308.96,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 401.51,
    "cy": 298.87,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 401.51,
    "cy": 288.77,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 401.51,
    "cy": 278.68,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 278.68,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 288.77,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 298.87,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 308.96,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 218.4,
    "cy": 431.28,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 218.4,
    "cy": 421.18,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 218.4,
    "cy": 411.09,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 218.4,
    "cy": 400.99,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 357.56,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 375.41,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 393.25,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": -1.9,
    "endAngle": 2.2
  },
  {
    "cx": 220.36,
    "cy": 464.62,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 482.46,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 446.78,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0.81,
    "endAngle": 5.77
  },
  {
    "cx": 220.36,
    "cy": 339.72,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 321.88,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 250.51,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 268.35,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 232.67,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 220.36,
    "cy": 214.83,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  },
  {
    "cx": 407.26,
    "cy": 278.68,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0.73,
    "endAngle": 2.41
  },
  {
    "cx": 407.26,
    "cy": 288.77,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0.73,
    "endAngle": 2.41
  },
  {
    "cx": 407.26,
    "cy": 298.87,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0.73,
    "endAngle": 2.41
  },
  {
    "cx": 407.26,
    "cy": 308.96,
    "rx": 2.72,
    "ry": 1.24,
    "startAngle": 0.73,
    "endAngle": 2.41
  },
  {
    "cx": 220.36,
    "cy": 196.98,
    "rx": 5.88,
    "ry": 0.88,
    "startAngle": 0,
    "endAngle": 6.28
  }
],
  texts: [
  {
    "x": 324.23,
    "y": 498.29,
    "text": "Kablo Bağı",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 27.39,
    "y": 619.1,
    "text": "Duvara tespit (mesnet) parçaları",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 330.63,
    "y": 656.83,
    "text": "(2 adet)",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 338.66,
    "y": 643.69,
    "text": "Dübel",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 44.99,
    "y": 533.47,
    "text": "L=150cm",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 525.16,
    "y": 712.97,
    "text": "Kapı",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 231.25,
    "y": 751.47,
    "text": "Kablo şaftının dış yüzü duvar veya",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 230.7,
    "y": 765.47,
    "text": "uygun malzeme ile kapatılacaktır",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 24.71,
    "y": 719.49,
    "text": "Civatalar",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 38.75,
    "y": 720.09,
    "text": "(4 adet)",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 0,
    "y": 208.89,
    "text": "Dikme",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 242.61,
    "y": 268.74,
    "text": "Katlara ait telefon kabloları",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 260.86,
    "y": 268.74,
    "text": "Katlara ait televizyon kabloları",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 287.41,
    "y": 268.74,
    "text": "Her bir kolon hattı kablosu aralarında",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 300.22,
    "y": 268.74,
    "text": "kablo çapının en az 2 katı veya 1 katı",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 313.04,
    "y": 268.74,
    "text": "açıklık bırakılarak veya birbirlerine dokunmalı",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 325.85,
    "y": 268.74,
    "text": "olarak tek sıra halinde basamaklara kablo bağı",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 339.27,
    "y": 268.74,
    "text": "veya kroşe ile bağlanacaktır.",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 463.11,
    "y": 364.4,
    "text": "Havalandırma Panjuru",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 327.18,
    "y": 425.67,
    "text": "Basamak",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 650.88,
    "y": 327.26,
    "text": "(Ek) Parçası",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 636.12,
    "y": 327.26,
    "text": "Düz Birleştirme",
    "height": 9.28,
    "rotation": 90
  },
  {
    "x": 302.62,
    "y": 0,
    "text": "50cm",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 298.87,
    "y": 18.74,
    "text": "20cm",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 405.85,
    "y": 172.9,
    "text": "h=4",
    "height": 9.28,
    "rotation": 0
  },
  {
    "x": 11.38,
    "y": 839.35,
    "text": "{-Yangın Yönetmeliğini 69. Maddesi gereğince katlar arası yatay ve düşey yangın alevinin ve / veya dumanın geçişini engellemek üzere bütün açıklıkların kapatılması gerekmektedir. (Katlar arası+ müdahale kapağı)}",
    "height": 12.49,
    "rotation": 0
  }
],
};
